'use client'

import { Button } from '@src/components/Button/Button'
import { LocalizedLink } from '@src/components/LocalizedLink/LocalizedLink'
import { useTopNav } from '@src/components/TopNavV3/TopNavContext'
import { useTrackSelectNavCta } from '@src/utils/analytics.util'

export const TopNavMobileLinks = () => {
  const trackSelectNavCta = useTrackSelectNavCta()
  const { logInCta, signUpCta } = useTopNav()

  return (
    <div className="fixed bottom-0 left-0 flex w-screen flex-col gap-3 border-t border-bodi-gray-dark bg-bodi-black-text px-4 py-5">
      <LocalizedLink
        onClick={() => {
          trackSelectNavCta({ 'cta url': logInCta?.href })
        }}
        data-testid="logInBtn"
        href={logInCta?.href ?? ''}
        rel={logInCta?.newTab ? 'noopener noreferrer' : ''}
        target={logInCta?.newTab ? '_blank' : '_self'}
      >
        <Button className="w-full text-bodi-white" variant="secondary" size="medium">
          {logInCta?.title}
        </Button>
      </LocalizedLink>
      <LocalizedLink
        onClick={() => {
          trackSelectNavCta({ 'cta url': signUpCta?.href })
        }}
        data-testid="signUpBtn"
        href={signUpCta?.href ?? ''}
        rel={signUpCta?.newTab ? 'noopener noreferrer' : ''}
        target={signUpCta?.newTab ? '_blank' : '_self'}
      >
        <Button className="w-full" variant="primary" size="medium">
          {signUpCta?.title}
        </Button>
      </LocalizedLink>
    </div>
  )
}
